export default "__VITE_ASSET__CcKe6gb2__"